const videoModule = ( $ ) => {
	$( '.video-module__play-btn' ).on( 'click', function ( e ) {
		e.preventDefault();

		const $btn = $( this );
		const $container = $btn.closest( '.video-module__player' );
		const $overlay = $container.find( '.video-module__overlay' );
		const type = $container.data( 'video-type' );
		const isSilent = String( $container.data( 'video-silent' ) ) === '1';

		$btn.fadeOut();
		$overlay.fadeOut();

		if ( type === 'file' ) {
			const $video = $container.find( 'video' );
			if ( $video.length ) {
				const videoEl = $video[ 0 ];
				videoEl.muted = isSilent;
				videoEl.volume = isSilent ? 0 : 1;
				videoEl.loop = false;
				videoEl.controls = true;
				videoEl.play();
			}
		} else if ( type === 'oembed' ) {
			const $template = $container.find(
				'.video-module__oembed-template'
			);
			const $poster = $container.find( '.video-module__poster' );

			if ( $template.length ) {
				$poster.fadeOut();
				$container.append( $template.html() );
			}
		}
	} );
};

export default ( ( $ ) => $( videoModule ) )( jQuery );
